import { render, staticRenderFns } from "./shopdetail.vue?vue&type=template&id=a9889560&scoped=true"
import script from "./shopdetail.vue?vue&type=script&lang=js"
export * from "./shopdetail.vue?vue&type=script&lang=js"
import style0 from "./shopdetail.vue?vue&type=style&index=0&id=a9889560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9889560",
  null
  
)

export default component.exports